

























































































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';
import ProjectIcon from '@/components/common/ProjectIcon.vue';
import { AccountBasicParticipationProject } from '@/@types/Account';
import CommonModalHeader from '@/components/common/CommonModalHeader.vue';
import { vxm } from '@/store';
import ProjectAddModal from '@/components/common/ProjectAddModal.vue';

@Component({
  components: {
    OrganizationIcon,
    ProjectIcon,
    CommonModalHeader,
    ProjectAddModal,
  },
})
export default class CommonHeader extends Vue {
  @Prop({ required: true, default: [] })
  private participationProjects!: AccountBasicParticipationProject[];
  @Prop({ type: Boolean, default: true })
  public isProjectMenuRequired!: boolean;
  private isOpenProjectList: boolean = false;
  private organizationAvatarSize: number = 32;
  private organizationAvatarColor: string = '#fdb44d';
  private projectAvatarSize: number = 32;
  private projectAvatarColor: string = '#fdb44d';
  private isOpenAddProjectModal: boolean = false;

  private closeAddProjectModal(isOpenAddProjectModal: boolean) {
    this.isOpenAddProjectModal = isOpenAddProjectModal;
  }

  private async onChangeProject(
    project: AccountBasicParticipationProject,
  ) {
    const projectId = project.projectId;
    vxm.theoryApi.authStore.fetchCurrentProjectId(projectId);
    vxm.theoryApi.authStore.fetchCurrentProjectName(project.projectName);
    this.resetState();
    await Promise.all([
      vxm.theoryApi.projectsStore.fetchProjectBasic(projectId),
      vxm.theoryApi.projectMembersStore.fetchProjectMembersById(projectId),
      vxm.theoryApi.activitiesStore.fetchProjectActivities({
        projectIds: [projectId],
        organizationId: this.organizationId as number
      }),
      vxm.theoryApi.tasksStore.fetchTasks({'project-id': projectId}),
    ]);
    if (this.$route.name !== 'home') {
      this.$router.push({ name: 'home' });
    }
  }

  private resetState() {
    vxm.theoryApi.directoriesStore.deleteDirectoriesAndFiles();
    vxm.theoryApi.directoriesStore.deleteParentDirectory();
    vxm.theoryApi.directoriesStore.deleteCurrentDirectory();
    vxm.theoryApi.projectMembersStore.deleteProjectMembers();
    vxm.theoryApi.projectsStore.deleteProject();
    vxm.theoryApi.projectsStore.deleteProjectAll();
    vxm.theoryApi.projectsStore.deleteTaskAttributeValueOptions();
    vxm.theoryApi.tasksStore.deleteTask();
    vxm.theoryApi.tasksStore.deleteTasks();
    vxm.theoryApi.tasksStore.deleteTaskComments();
  }

  private get organizationId() {
    return vxm.theoryApi.authStore.getCurrentOrganizationId;
  }

  private get currentProjectName() {
    return vxm.theoryApi.authStore.getCurrentProjectName;
  }

  private get accountId() {
    const response = vxm.theoryApi.authStore.getCurrentUserInfo;
    if (response) {
      return response.results.accountId;
    } else return null;
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId;
  }

  @Emit('addProjectName')
  private addProjectName() {}
}
